// @flow
import React from 'react';
import { css } from 'react-emotion';
import { components, colors, elements } from '@peachjar/components';
import Check from '@material-ui/icons/Check';

const { ButtonSecondarySmall } = components.Buttons;
const { TextInput } = components;
const { jungle } = colors;
const { Spinner } = components.LoadingIndicators;

const SchoolLink = ({ url, name }) => (
  <a
    className={styles.link}
    href={url}
    rel="noopener noreferrer"
    target="_blank"
  >
    {name}
  </a>
);

type Props = {
  /**
   * Url to flyer approval guidelines
   */
  flyerApprovalGuidelinesUrl: string,
  /**
   * Function that gets called when url changes
   */
  handleFlyerApprovalGuidelinesUrlChange: () => void,
  /**
   * True if the url passes validation
   */
  isValidUrl: boolean,
};

const FlyerApprovalGuidelines = ({
  flyerApprovalGuidelinesUrl,
  handleFlyerApprovalGuidelinesUrlChange,
  isValidUrl,
}: Props) => {
  const getAdornment = () => {
    if (isValidUrl) {
      return <Check id="check" style={{ color: jungle }} />;
    }
    return flyerApprovalGuidelinesUrl === '' ? <React.Fragment /> : <Spinner />;
  };

  return (
    <div className="pr-5">
      <p>
        The following should be placed on your district website to inform
        community organizations of your digital flyer system. Selecting the most
        appropriate web-page to place this information depends on the
        configuration of your website.
      </p>
      <p>
        Below are a few examples of how school districts have placed this
        information on their district website.
      </p>
      <ul className={styles.list}>
        <li>
          <SchoolLink
            url="https://www.fwcs.k12.in.us/files/public_affairs/PA003.pdf"
            name="Fort Wayne Community Schools"
          />
        </li>
        <li>
          <SchoolLink
            url="http://www.fcusd.org/Page/17702"
            name="Folsom Cordova Unified School District"
          />
        </li>
        <li>
          <SchoolLink
            url="http://www.nvusd.org/extflyers"
            name="Napa Valley Unified School District"
          />
        </li>
      </ul>
      <p>We created a sample template to help you get started with yours.</p>
      <ButtonSecondarySmall href="https://cdn-assets.peachjar.com/portal-app/onboarding/Flyer+Approval+Guidelines+Template.docx">
        Download Template
      </ButtonSecondarySmall>
      <p />
      <p>
        Once you have created your flyer approval guidelines and added it to
        your website, please enter the URL of the specific webpage where you
        added it below.
      </p>

      <TextInput
        type="url"
        id="urlTextInput"
        endAdornment={getAdornment()}
        onChange={handleFlyerApprovalGuidelinesUrlChange}
        label="Flyer Guidelines URL"
        fullWidth
        data-testid="flyerGuidelinesUrlTextInput"
        placeholder="E.g. http://www.mydistrict.edu/flyer_guidelines"
      />
      <div className="spacer" style={{ paddingBottom: '1.75rem' }} />
    </div>
  );
};

const styles = {
  // https://github.com/emotion-js/emotion/issues/287
  link: css`
    &,
    &:active,
    &:visited,
    &:hover {
      color: ${jungle};
    }
  `,
  list: css`
    li {
      color: ${jungle};
    }
  `,
};

export default FlyerApprovalGuidelines;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/organization/components/FlyerApprovalGuidelines.jsx